const firebaseConfigString = import.meta.env.VITE_FIREBASE_CONFIG_ADMIN;
export const baseApiUrl = import.meta.env.VITE_BASE_URL || 'https://api.cheapwaste.com';
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

export const VITE_ENV = import.meta.env.VITE_ENV || 'production';
export const FIREBASE_AUTH_EMULATOR_HOST = import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_HOST;

export const SENTRY_DSN =
  import.meta.env.VITE_SENTRY_DSN ||
  'https://cf343ccf6f4b8f07292cbc1b5bf6c49a@o4509935133065216.ingest.us.sentry.io/4509935135031296';
export const SENTRY_RELEASE = import.meta.env.VITE_SENTRY_RELEASE;
export const SENTRY_ENABLED = import.meta.env.VITE_SENTRY_ENABLED !== 'false';

export const firebaseConfig = firebaseConfigString
  ? JSON.parse(firebaseConfigString)
  : {
      apiKey: 'AIzaSyAy4PHskb-WzLxva4NVRsJjzgrJPog5ou8',
      authDomain: 'upwaste-prod.firebaseapp.com',
      projectId: 'upwaste-prod',
      storageBucket: 'upwaste-prod.appspot.com',
      messagingSenderId: '314302373112',
      appId: '1:314302373112:web:7d66fdf865e7963874af0d',
      measurementId: 'G-TN20PPTCPR',
    }; // This is the default prod config

export const isLocal = VITE_ENV === 'local';
